// @ts-nocheck
import i18n from 'i18next';

/**
 * LocaleValue - Components of date and time formats
 * https://tc39.es/ecma402/#datetimeformat-objects
 */

type TimeZoneOptions = { [timeZone: string]: string };
type LocaleValue = 'narrow' | 'short' | 'long' | '2-digit' | 'numeric';
type LocaleOptions = { [property: string]: LocaleValue };

const timeZoneOptions: TimeZoneOptions = {
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

const localeDateOptions: LocaleOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  ...timeZoneOptions,
};

const localeTimeOptions: LocaleOptions = {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  ...timeZoneOptions,
};

const localeDateTimeOptions: LocaleOptions = {
  ...localeDateOptions,
  ...localeTimeOptions,
};

/**
 * format - use this format function for all format challenges.
 * @param value the value of the raw data
 * @param format the format template that is supported by i18next
 * @param lng the ISO locale keyword
 *
 * Locale - Current {Date} is matched to support three types of predefined
 * locale transformation.
 * Todo -This could be swapped with a solution that would allow to pass in
 * user-defined formatter template.
 *
 */

export const format = (
  value: any,
  format: string | undefined,
  lng: string | undefined,
) => {
  if (value instanceof Date) {
    if (format === 'DATE') {
      return value.toLocaleDateString(lng, localeDateOptions);
    }
    if (format === 'TIME') {
      return value.toLocaleTimeString(lng, localeTimeOptions);
    }
    return value.toLocaleString(lng, localeDateTimeOptions);
  }
  return value;
};

export default i18n;
